import { NullTemplateVisitor } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BuNameService } from '../../helper/core/bu-name.service';
import { CoreService } from '../../helper/core/core.service';

@Component({
  selector: 'app-search', 
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  events: any = null;
  paramsSearch: string = null;

  constructor(
    private route: ActivatedRoute,
    private coreService: CoreService,
    private router: Router,
    private buNameService: BuNameService
  ) { }

  goToEvent(eventSlug) {
    this.router.navigate(['/'+this.route.snapshot.paramMap.get('bu')+'/'+eventSlug]);
  }

  goToHomepage(){
    this.router.navigate(['/'+this.route.snapshot.paramMap.get('bu')]);
  }

  ngOnInit() {
    this.route.queryParamMap
      .subscribe((params) => {
        this.coreService.getSearchResult(this.route.snapshot.paramMap.get('bu'), params).subscribe(
          data => {
            this.paramsSearch = this.route.snapshot.queryParamMap.get('query');
            this.events = data.result;
          }
        )
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/search/search.component.ts